import React, { useContext } from 'react';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import WDSIconButton, { IconButtonProps } from '../IconButton';
import { SplitActionContext } from './SplitActionContext';
import { st, classes } from './SplitAction.st.css';

export const SplitActionIconButton: React.FC<IconButtonProps> = ({
  children,
  className,
  ...rest
}) => {
  const shared = useContext(SplitActionContext);
  return (
    <WDSIconButton
      {...shared}
      {...rest}
      data-split-action-button
      className={st(classes.splitActionIconButton, className)}
      ariaLabel={rest.ariaLabel}
    >
      {children || <ChevronDown />}
    </WDSIconButton>
  );
};
SplitActionIconButton.displayName = 'SplitActionIconButton';
